import { useState } from "react";

import { Button, ButtonIconWithLabel, Icon_OpenNew24, Link } from "@shapr3d/frontend-lib";

import { CollaborationPromoURL } from "../../config";
import { useTracker } from "../../hooks/useTracker";
import { ElementClickAction, ElementClickLocation } from "../../lib/TrackingAdapter";
import { PublishVersionModal } from "./components/PublishVersionModal";

import style from "./PublishVersionPromo.module.css";

interface PublishVersionPromoProps {
  canPublish: boolean;
}

export const PublishVersionPromo = ({ canPublish }: PublishVersionPromoProps) => {
  const tracker = useTracker();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={style.container}>
      <div className={style.content}>
        <div className={style.title}>
          {canPublish ? "Publish your first version" : "No version published yet"}
        </div>
        <div className={style.description}>
          {canPublish
            ? "Open the Shapr3D app to publish the current version of this project."
            : "You need to be an Editor to publish the current version of this project."}
        </div>
        <div className={style.actions}>
          {canPublish && (
            <Button
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              <ButtonIconWithLabel icon={<Icon_OpenNew24 />} label="Publish Current Version..." />
            </Button>
          )}
          <Link
            href={CollaborationPromoURL}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.LEARN_MORE_PUBLISHING_VERSIONS,
                location: ElementClickLocation.PROJECT_PAGE,
              });
            }}
          >
            Learn more about publishing versions...
          </Link>
        </div>
      </div>
      {canPublish && (
        <PublishVersionModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
      )}
    </div>
  );
};
